export default {
  /**
   * Set the List items
   *
   * @param state
   * @param items
   */
  setEmployeeAdminList(state, items) {
    state.items = items;
  },

  /**
   * Set List pagination meta
   *
   * @param state
   * @param pagination
   */
  setEmployeeAdminListPagination(state, pagination) {
    state.pagination = pagination;
  },

  /**
   * Set List current page
   *
   * @param state
   * @param currentPage
   */
  setEmployeeAdminListPage(state, currentPage) {
    state.pagination.current_page = currentPage;
  },

  /**
   * Set search filters.
   *
   * @param state
   * @param filters
   */
  setEmployeeAdminListFilters(state, filters) {
    state.filters = filters;
  },

  /**
   * Set user is busy.
   *
   * @param state
   * @param isBusy
   */
  setEmployeeAdminListBusy(state, isBusy) {
    state.isBusy = isBusy;
  },
};
